import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'lib-perio-done',
  imports: [SvgIconComponent, TranslatePipe],
  templateUrl: './perio-exam-done.component.html',
  styleUrl: './perio-exam-done.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class PerioExamDoneComponent {}
